export default __webpack_public_path__ + "static/media/ProgressStage3.034efea2.svg";